const EventHandler = (state) => {
  if (typeof state === 'undefined') {
    return {};
  }

  return state;
};

export default EventHandler;



// WEBPACK FOOTER //
// ./src-react/FormSwiftAPI/Event/EventReducer.jsx